let handler = null;

/** @param {(() => void) | null} fn */
export function setPermission403Handler(fn) {
  handler = fn;
}

export function notifyPermission403() {
  if (handler) handler();
}
